import { Theme } from 'config';

const styles = (theme: Theme) => ({
  segmentGrid: {
    margin: '0 !important',
  },
  header: {
    color: `${theme.deepPurple} !important`,
    fontSize: '1.25rem !important',
    textAlign: 'left !important',
    paddingBottom: '.75rem !important',
  },
  offerHidden: {
    fontSize: '1.5rem !important',
    textAlign: 'left !important',
    paddingBottom: '.75rem !important',
    color: `${theme.seafoamGreen} !important`,
  },
  dateRow: {
    padding: '0 !important',
  },
  segmentProps: {
    paddingTop: '.25rem !important',
  },
  segmentHeaderRow: {
    padding: '1rem 0 0 0 !important',
  },
  segmentDetailRow: {
    padding: '0 0 0 .5rem !important',
    display: 'block !important',
  },
  textLabel: {
    fontSize: '1.1rem',
    marginRight: '.5rem',
    marginBottom: '0',
    fontWeight: 'bold',
  },
  spacer: {
    paddingRight: '1rem !important',
    paddingBottom: '.5rem !important',
  },
  listItems: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    float: 'right',
  },
  container: {
    display: 'flex !important',
    flexDirection: 'column !important',
    paddingLeft: '.5rem',
    marginBottom: '1rem',
  },
  noMargin: {
    margin: '0 !important',
  },
  button: {
    backgroundColor: `${theme.coral} !important`,
    marginLeft: '1rem !important',
  },
  terminateBtn: {
    backgroundColor: `${theme.seafoamGreen} !important`,
  },
  modifyButton: {
    backgroundColor: `${theme.yellow} !important`,
  },
  buttonSecondary: {
    marginRight: '.45rem !important',
    backgroundColor: `${theme.softGray} !important`,
    color: `${theme.darkGray} !important`,
    height: '3.125rem',
    '&:hover': {
      boxShadow:
        '0 0 0 .0625rem transparent inset,0 0 0 0 rgba(34,36,38,.15) inset !important',
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
  },
  mediumBtn: {
    width: '48% !important',
  },
  throttleUpdBtn: {
    backgroundColor: `${theme.violet} !important`,
    color: '#000 !important',
    margin: '0 !important',
    '&:hover': {
      boxShadow:
        '0 0 0 .0625rem transparent inset,0 0 0 0 rgba(34,36,38,.15) inset !important',
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
  },
  tertiaryBtn: {
    backgroundColor: `${theme.softViolet} !important`,
    color: '#000 !important',
    height: '3.125rem',
    margin: '0 !important',
    '&:hover': {
      boxShadow:
        '0 0 0 .0625rem transparent inset,0 0 0 0 rgba(34,36,38,.15) inset !important',
      opacity: 0.9,
    },
    '&:active': {
      opacity: 0.7,
    },
  },
  throttleContainer: {
    display: 'flex',
  },
});

export default styles;
